var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"margin-bottom":"20px"}},_vm._l((_vm.numPages),function(i){return _c('pdf',{key:i,ref:"pdf",refInFor:true,attrs:{"src":_vm.loadingTask,"page":i}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }